/**
 * Vibe — Odyssey universe-building app.
 *
 * U2.3 shipped the first read catalogs (Races, Abilities). U2.4 added the
 * owner-tier Ability creator. U2.5 surfaces the rest of the seeded canon
 * graph as tabs: Characters (roster), Realms, Worlds.
 */

import { useState } from "react";

import { AbilityCatalog } from "./views/AbilityCatalog.js";
import { CharacterCatalog } from "./views/CharacterCatalog.js";
import { RaceCatalog } from "./views/RaceCatalog.js";
import { RealmCatalog } from "./views/RealmCatalog.js";
import { WorldCatalog } from "./views/WorldCatalog.js";

type Tab = "characters" | "races" | "abilities" | "realms" | "worlds";

const TABS: { id: Tab; label: string }[] = [
  { id: "characters", label: "Characters" },
  { id: "races", label: "Races" },
  { id: "abilities", label: "Abilities" },
  { id: "realms", label: "Realms" },
  { id: "worlds", label: "Worlds" },
];

export function App() {
  const [tab, setTab] = useState<Tab>("characters");

  return (
    <div className="app-shell">
      <header className="app-header">
        <h1>Vibe</h1>
        <span className="subtitle">Odyssey · canon graph</span>
      </header>
      <nav className="app-nav">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={tab === t.id ? "active" : ""}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </nav>
      <main>
        {tab === "characters" && <CharacterCatalog />}
        {tab === "races" && <RaceCatalog />}
        {tab === "abilities" && <AbilityCatalog />}
        {tab === "realms" && <RealmCatalog />}
        {tab === "worlds" && <WorldCatalog />}
      </main>
    </div>
  );
}
